import React from 'react'
import { Input, Select, Switch } from 'components/common'


const editors = {
	select: (model, name, onValuedChanged, filter) => <Select options={hp.store.products} model={model} name={name} {...filter.params || null} onChange={onValuedChanged} />,
	date: (model, name, onValuedChanged, filter) => <Input type="date" model={model} name={name} {...filter.params || null} onBlur={onValuedChanged} />,
	bool: (model, name, onValuedChanged, filter) => <Switch model={model} name={name} {...filter.params || null} onChange={onValuedChanged} />
}

export default class AdvancedFilter extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			filterString: null,
			filters: [],
			selected: 0
		}
	}

	static getDerivedStateFromProps(props, state) {
		if (state.filterString == props.filter) {
			return null;
		}
		const filters = props.filter ? JSON.parse(props.filter) : []
		let current = state.current || props.current
		let selected = props.selected || (current ? current.name : null)
		let selected_index = 0;

		if (selected) {
			// reposicionar o current
			for (let i in filters) {
				if (filters[i].name == selected) {
					current = filters[i]
					selected_index = parseInt(i) + 1
					break
				}
			}
		}
		filters.unshift({
			name: '(novo filtro)',
			_isnew: true,
			filter: []
		})
		return {
			filterString: props.filter || '',
			filters: filters,
			current: current || filters[0],
			selected: selected_index
		}
	}

	onChangeFilter = (e) => {
		const filter = this.state.filters[e.currentTarget.value]
		this.setState(
			{
				current: filter,
				selected: e.currentTarget.value
			}, () => {
				if (this.props.autoApply === undefined || this.props.autoApply === true) {
					this.onApply()
				}
			}
		)
	}

	onChangeField(name, filter) {
		this.state.current.filter.push({
			name: name,
			value: null
		})
		this.forceUpdate()
	}

	formatCurrent() {
		const {current} = this.state
		const {models} = this.props

		// percorrer todos os filtros e limpar os que não têm valor definido
		for (let i = current.filter.length - 1; i >= 0; i -= 1) {
			const f = current.filter[i]
			if (f.value === null && (!models.hasOwnProperty(f.name) || models[f.name].type != 'bool')) {
				current.filter.splice(i, 1)
			}
		}
	}

	onSave = () => {
		const {name} = this.props
		const {filters} = this.state

		if (!name) {
			alert('nome para este filtro avançado não definido!')
			return
		}
		this.formatCurrent()
		// verificar se primeiro filtro está vazio
		if (filters.length > 0 && filters[0]._isnew && filters[0].filter.length > 0) {
			// renomear o filtro
			let _name = prompt('Indique nome para o novo filtro', filters[0].name)
			if (_name == null) {
				return
			}
			filters[0].name =_name
			filters[0]._isnew = false
		}
		const filter_string = JSON.stringify(filters)
		http.post('dynamicfilters/saveAdv.json', {
			name: name,
			filter: filter_string
		}, (response, status) => {
			if (status && this.props.onAfterSave) {
				this.props.onAfterSave(response.filter)
			}
		})
	}

	onApply = () => {
		this.formatCurrent();
		const {filters, filterString, current} = this.state
		const filter_string = JSON.stringify(filters)

		if (filterString !== filter_string) {
			this.forceUpdate()
		}
		if (this.props.onApply) {
			this.props.onApply(current)
		}
	}

	onClear = () => {
		if (this.props.onApply) {
			this.props.onApply(null)
		}
	}

	onRemove(index) {
		this.state.current.filter.splice(index, 1);
		if (this.props.autoApply === undefined || this.props.autoApply === true) {
			this.onApply()
		}
		else {
			this.forceUpdate()
		}
	}

	onRemoveCurrent = () => {
		const {current, filters} = this.state

		for (let i in filters) {
			if (filters[i] === current) {
				filters.splice(i, 1);
				let selected = i < filters.length ? i : (i == 0 ? 0 : (i - 1))
				this.setState({
					selected: selected,
					current: filters.length > 0 ? filters[selected] : {name: '(novo filtro)', filter: []}
				})
				if (this.props.autoApply === undefined || this.props.autoApply === true) {
					this.onApply()
				}
				return
			}
		}
	}

	onValuedChanged = (e) => {
		if (this.props.autoApply === undefined || this.props.autoApply === true) {
			this.onApply()
		}
		else {
			this.forceUpdate()
		}
	}

	render() {
		const {current, selected, filters} = this.state
		const {models} = this.props
		const _options = filters.map((filter, i) =>
			<option key={i} value={i}>{filter.name}</option>
		)
		const filter_fields = Object.keys(models).map(name => {
			const model = models[name];
			return (
				<li key={name}><a onClick={this.onChangeField.bind(this, name, model)}>{model.label}</a></li>
			)
		})
		const btn_add =
			<div className="btn-group">
				<button className="btn dropdown-toggle btn-transparent btn-circular" data-toggle="dropdown" aria-haspopup="true">
					<em className="la la-plus" />
				</button>
				<ul className="dropdown-menu">{filter_fields}</ul>
			</div>
		const last_idx = current.filter.length - 1
		const _fields = current.filter.map((filter, i) => {
			const model = models[filter.name]
			return (
				<div key={i} className="adv-filter">
					<div className="label">{model.label}</div>
					<div className="editor">
						{editors[model.type](filter, 'value', this.onValuedChanged, model)}
					</div>
					<button className="btn btn-transparent btn-xs btn-circular-xs" onClick={this.onRemove.bind(this, i)}>
						<em className="la la-times" />
					</button>
					{i === last_idx ? btn_add : null}
				</div>
			)
		})
		return (
			<div>
				<div className="adv-filter">
					<select className="form-control" onChange={this.onChangeFilter} value={selected}>{_options}</select>
					<div className="btn-group">
						<button className="btn btn-default btn-circular" title="Limpar filtro" onClick={this.onClear}>
							<em className="la la-eraser"></em>
						</button>
					</div>
					{this.props.autoApply === false
					 ? <div className="btn-group">
						<button className="btn btn-default btn-circular" title="Aplicar" onClick={this.onApply}>
							<em className="la la-filter"></em>
						</button>
					   </div>
					 : null
					}
					{current.filter.length === 0 ? null :
						<div className="btn-group">
							<button className="btn btn-default btn-circular" title="Eliminar filtro atual" onClick={this.onRemoveCurrent}>
								<em className="la la-trash"></em>
							</button>
						</div>}
					<div className="btn-group">
						<button className="btn btn-default btn-circular" title="Gravar filtro" onClick={this.onSave}>
							<em className="la la-save"></em>
						</button>
					</div>
					{current.filter.length === 0 ? btn_add : null}
				</div>
				{_fields}
			</div>
		)
	}
}
